import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

EDC.Games.TranslateNumberToTenFrame.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.TranslateNumberToTenFrame, 46]);
  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.gameData = EDC.Games.TranslateNumberToTenFrame.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.number = [];
  this.stars = [];
  this.starsOnGrid = [];
  this.grid = null;
  this.gridStars = 0;
  this.visibleStars = [];
};

// eslint-disable-next-line max-len
EDC.Games.TranslateNumberToTenFrame.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.TranslateNumberToTenFrame.Scenes.Main.prototype.constructor = EDC.Games.TranslateNumberToTenFrame.Scenes.Main;

const TNTTF = EDC.Games.TranslateNumberToTenFrame.Scenes.Main.prototype;

TNTTF.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.addSubmitButton();
  this.loadIteration();

  this.createBasicUI();
};

TNTTF.createTemplateUI = function () {
  this.add.sprite(515, 95, 'title').setOrigin(0);
  this.add.sprite(200, 250, 'instructions-frame').setOrigin(0);
  this.add.sprite(245, 290, 'instructions').setOrigin(0);
  this.grid = this.add.sprite(440, 370, 'grid').setOrigin(0);
  const buttonGreen = this.add.sprite(759, 961, 'button-green').setScale(0.51);
  const buttonRed = this.add.sprite(635, 961, 'button-red').setScale(0.5);
  this.colorAnim(buttonGreen, buttonRed);
};

TNTTF.loadIteration = function () {
  this.createStars();
  this.fillGrid();
  this.addNumber();
};

TNTTF.nextIteration = function () {
  this.number[0].first.destroy();
  this.number.pop();
  this.number = [];
  this.stars.map((x) => {
    x.destroy();
    return true;
  });
  this.stars = [];
  this.starsOnGrid.map((x) => {
    x.destroy();
    return true;
  });
  this.starsOnGrid = [];
  this.gridStars = 0;
  this.iteration = this.iteration + this.iteration;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

// stars outside grid are called stars while stars on grid are called starsOnGrid
// and function names follow same format
TNTTF.colorAnim = function (sprite1, sprite2) {
  sprite1.setTint(0x999999);
  sprite2.setTint(0xffffff);
  this.time.delayedCall(1500, this.colorAnim2, [sprite1, sprite2], this);
};

TNTTF.colorAnim2 = function (sprite1, sprite2) {
  sprite1.setTint(0xffffff);
  sprite2.setTint(0x999999);
  this.time.delayedCall(1500, this.colorAnim, [sprite1, sprite2], this);
};

TNTTF.createStars = function () {
  for (let i = 0; i < 10; i++) {
    const star = this.add.sprite(665, 835, 'star').setScale(0.3);
    star.x += i * star.displayWidth;
    this.stars.push(star);
  }
};

TNTTF.addNumber = function () {
  const { correctAnswer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const font = {
    font: `200px ${this.gameConfig.font}`,
  };
  const numberContainer = this.add.container(235, 610);
  numberContainer.setSize(200, 200);
  const bubble = this.add.sprite(0, 0, 'bubble');
  const number = this.add.text(0, 0, correctAnswer, font).setOrigin(0.5);
  numberContainer.add(bubble);
  numberContainer.add(number);
  this.number.push(numberContainer);
  this.scaleNumber(numberContainer);
};

TNTTF.fillGrid = function () {
  const rect = new Phaser.Geom.Rectangle(500, 430, 870, 330);
  const gridHitArea = this.add.graphics({ fillStyle: { alpha: 0 } });
  gridHitArea.fillRectShape(rect);
  gridHitArea.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
  this.cursorManager.setDefaultDraggableEvents(gridHitArea);
  for (let i = 0; i < 10; i++) {
    const { x, y } = this.getStaronGridPosition(i);
    const starContainer = this.add.container(x, y).setAlpha(0.000001);
    const star = this.add.sprite(0, 0, 'star');
    starContainer.add(star);
    starContainer.invisible = true;
    starContainer.setSize(150, 150);
    // eslint-disable-next-line no-shadow
    const rect = new Phaser.Geom.Rectangle(-50, 0, 150, 150);
    starContainer.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
    this.cursorManager.setDefaultDraggableEvents(starContainer);
    starContainer.on('pointerup', this.addStarOnGrid.bind(this, starContainer), this);
    this.starsOnGrid.push(starContainer);
  }
};

TNTTF.addStarOnGrid = function (star) {
  if (star.invisible) {
    this.gridStars = this.gridStars + 1;
    this.updateStars();
    star.setAlpha(1);
    star.invisible = false;
  } else if (!star.invisible) {
    this.gridStars = this.gridStars - 1;
    this.updateStars();
    star.setAlpha(0.000001); // absolute zero will remove the object from the game.
    star.invisible = true;
  }
};

TNTTF.updateStars = function () {
  this.stars.map((x) => {
    x.destroy();
    return true;
  });
  this.stars = [];
  for (let i = 0; i < 10 - this.gridStars; i++) {
    const star = this.add.sprite(665, 835, 'star').setScale(0.3);
    star.x += i * star.displayWidth;
    this.stars.push(star);
  }
};

TNTTF.getStaronGridPosition = function (i) {
  let x;
  let y;
  if (i < 5) {
    y = 510;
    x = 605 + i * 170;
  } else {
    y = 680;
    x = 605 + (i - 5) * 170;
  }
  return { x, y };
};

TNTTF.addSubmitButton = function () {
  const button = this.add.sprite(1270, 960, 'done');
  const rect = new Phaser.Geom.Rectangle(0, 0, 110, 110);
  button.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
  this.scaleNumber(button, 2000);
  this.cursorManager.setDefaultDraggableEvents(button);
  button.on('pointerup', this.checkAnswer, this);
};

TNTTF.checkAnswer = function () {
  const { correctAnswer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  if (this.gridStars === correctAnswer) {
    this.playCorrect();
    this.time.addEvent({ delay: 2000, callback: this.nextIteration, callbackScope: this });
  } else if (this.gridStars > 0) {
    this.playWrong();
    this.wrongAnimation();
  }
};

TNTTF.scaleNumber = function (sprite, delay) {
  let randomDelay = delay;
  if (!delay) {
    randomDelay = 300;
  }
  sprite.scaleAnim = this.tweens.add({
    targets: sprite,
    scaleX: 1.25,
    scaleY: 1.25,
    duration: 400,
    ease: 'Sine.easeInOut',
    delay: randomDelay,
    yoyo: true,
    onComplete: this.scaleNumber.bind(this, sprite, 5000 + Math.floor(Math.random() * 3000)),
  });
};

TNTTF.wrongAnimation = function () {
  this.grid.setTint(0xff0000);
  this.visibleStars = this.starsOnGrid.filter(x => !x.invisible);
  for (let i = 0; i < this.visibleStars.length; i++) {
    this.tweens.add({
      targets: this.visibleStars[i],
      y: this.visibleStars[i].y + 30,
      duration: 150,
      ease: 'Linear',
      onComplete: this.goUp.bind(this),
    });
  }
};

TNTTF.goUp = function () {
  for (let i = 0; i < this.visibleStars.length; i++) {
    this.tweens.add({
      targets: this.visibleStars[i],
      y: -200,
      duration: 750,
      ease: 'Linear',
      onComplete: this.restartRound.bind(this),
    });
  }
};

TNTTF.restartRound = function () {
  this.grid.clearTint();
  this.stars.map((x) => {
    x.destroy();
    return true;
  });
  this.stars = [];
  this.visibleStars.map((x) => {
    x.destroy();
    return true;
  });
  this.visibleStars = [];
  this.starsOnGrid.map((x) => {
    x.destroy();
    return true;
  });
  this.starsOnGrid = [];
  this.createStars();
  this.gridStars = 0;
  this.fillGrid();
};

export default EDC.Games.TranslateNumberToTenFrame.Scenes.Main;
